"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsAdmin = void 0;
const authApiClient_types_1 = require("root/src/server/util/awsClients/authApiClient.types");
const useGroups_1 = require("root/src/client/v2/auth/hooks/useGroups");
function useIsAdmin() {
    const { groups } = (0, useGroups_1.useGroups)();
    return {
        isAdmin: groups.includes(authApiClient_types_1.AuthGroup.Admin) || groups.includes(authApiClient_types_1.AuthGroup.SuperAdmin),
    };
}
exports.useIsAdmin = useIsAdmin;
